import {createFileRoute} from '@tanstack/react-router';
import {PaymentCallbackErrorPage} from 'features/shared/payment/pages';

export const Route = createFileRoute(
  '/_protected/statement-payment/$statementId/callback/_statuses/error',
)({
  component: () => (
    <PaymentCallbackErrorPage
      pageId="statement_payment_error"
      navigateTo="/home/statements"
    />
  ),
});
